const routes = [
  {
    path: '/residents',
    component: () => import('./1index.vue'),
  },
];

export default routes;
